import { Exchange } from 'urql';
import { pipe, tap } from 'wonka';
import { handleError } from './handle-error';

// error handling exchange - https://github.com/FormidableLabs/urql/issues/225
export const errorExchange: Exchange = ({ forward }) => (ops$) => {
  return pipe(
    forward(ops$),
    tap(({ error }) => {
      // If the OperationResult has an error send a request to sentry
      if (error) {
        handleError(error);
      }
    }),
  );
};
